import "../App.css";
import { useTranslation } from "react-i18next";
import information from "../svgs/information.svg";

function Colors() {
  const { t } = useTranslation();

  function displayColorInfo() {
    const infoMessage = document.getElementById('color-info-message');

    if (infoMessage.classList.contains('hidden')) { infoMessage.classList.remove('hidden'); }
    else { infoMessage.classList.add('hidden'); }
  }

  return (
    <>
      <div className="panel-section">
        <div className="section-header--color section-header section">
          {t('recommended_colors')}
          <div className="info">
            <div id="color-info-message" className="info__message hidden">
              <div className="info__message-text">{t('information_colors')}</div>
              <span className="info__message-arrow"></span>
            </div>
            <img
              onMouseEnter={displayColorInfo.bind(this)}
              onMouseLeave={displayColorInfo.bind(this)}
              className="clickable"
              src={information}
              alt="Information sign for accessing informations about recommended colors.">
            </img>
          </div>
        </div>
        <div className="line"></div>
        <div className="color-picker">
          <div
            id="white"
            style={{ color: "#161616", backgroundColor: "#F9F9F9" }}
            className="colors color-box"
          >
            001
          </div>
          <div
            id="black"
            style={{ color: "#F9F9F9", backgroundColor: "#161616" }}
            className="colors color-box"
          >
            66F
          </div>
          <div
            id="grey1"
            style={{ color: "#F9F9F9", backgroundColor: "#212323" }}
            className="colors color-box"
          >
            44F
          </div>
          <div
            id="grey2"
            style={{ color: "#F9F9F9", backgroundColor: "#585D5E" }}
            className="colors color-box"
          >
            34F
          </div>
          <div
            id="brown"
            style={{ color: "#F9F9F9", backgroundColor: "#26140E" }}
            className="colors color-box"
          >
            56F
          </div>
          <div
            id="grey3"
            style={{ color: "#F9F9F9", backgroundColor: "#5E5A56" }}
            className="colors color-box"
          >
            44F
          </div>

          {/* <img src={grey} id="grey1" alt="" />
          <img src={brown} id="brown" alt="" />
          <img src={black} id="black" alt="" />
          <img src={white} id="white" alt="" />
          <img src={grey2} id="grey2" alt="" />
          <img src={grey3} id="grey3" alt="" /> */}
        </div>
      </div>
    </>
  );
}

export default Colors;
